import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../_services/message.service';

import { User } from '../_models/user';
import { Globals } from '../_globals/globals';


@Injectable({
  providedIn: 'root'
})

export class UserService {

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {}

  /*getAllUsers() {
    this.http.get(this.globals.apiUrl + '/users')
      .subscribe(users => {
        this.users = users;
      });
  }*/
  getAllUsers(searchParams): Observable<User[]> {
    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: new HttpParams()
        .set('actived', searchParams.actived)
        .set('searchDesc', searchParams.searchDesc)
        .set('searchName', searchParams.searchName)
    };
    return this.http.get<User[]>(this.globals.apiUrl + '/users', options)
      .pipe(
        tap(  _ => this.log('fetched users')),
        catchError(this.handleError<User[]>('getAllUsers', [])
      ));
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}